import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {BUTTON_MAX, BUTTON_MIN} from './constant';

export const buttonValidator = z.object({
    type: z.literal(ELEMENT.BUTTON),
    text: z.string().min(BUTTON_MIN, `text;min;${BUTTON_MIN}`).max(BUTTON_MAX, `text;max;${BUTTON_MAX}`),
});
